import { render, staticRenderFns } from "./DrawSettings.vue?vue&type=template&id=8ce56d66&"
import script from "./DrawSettings.vue?vue&type=script&lang=js&"
export * from "./DrawSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports